import actionTypes from './actionTypes';

const INITIAL_STATE = {
  loading: false,
  failed: false,
  error: false,
  message: null,
  settings: [],
  errors: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_SETTINGS_LOADING:
      return {
        ...state,
        loading: true,
        failed: false,
        error: false,
        message: null,
        settings: [],
        errors: []
      };

    case actionTypes.GET_SETTINGS__SUCCESS:
      return {
        ...state,
        loading: false,
        failed: false,
        error: false,
        message: null,
        settings: [...action.payload.settings],
        errors: []
      };
    case actionTypes.GET_SETTINGS_FAILED:
      return {
        ...state,
        loading: false,
        failed: true,
        error: false,
        message
      };
    case actionTypes.GET_SETTINGS_REJECT:
      return {
        ...state,
        loading: false,
        failed: false,
        error: true,
        message: null
      };

    case actionTypes.UPDATE_SETTINGS_LOADING: {
      return {
        ...state,
        loading: true,
        failed: false,
        error: false,
        message: '',
        messages: []
      };
    }
    case actionTypes.UPDATE_SETTINGS_FAILED: {
      const { message, errors } = action.payload;
      return {
        ...state,
        loading: false,
        failed: true,
        error: false,
        message: message,
        messages: errors || []
      };
    }
    case actionTypes.UPDATE_SETTINGS_REJECT: {
      return {
        ...state,
        loading: false,
        failed: false,
        error: true,
        messages: []
      };
    }
    case actionTypes.UPDATE_SETTINGS_SUCCESS: {
      return {
        ...state,
        loading: false,
        failed: false,
        error: false,
        success: true,
        messages: []
      };
    }

    default:
      return state;
  }
};
